interface IPromiseRequestExtras {
    abort: () => void;
}

export class PromiseRequest<T> extends Promise<T> {
    private extras: IPromiseRequestExtras;

    constructor(
        executor: (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void,
        extras: IPromiseRequestExtras
    ) {
        super(executor)
        this.extras = extras;
        this._Abort = this._Abort.bind(this); // Enlazar el método _Abort al contexto de la instancia
    }

    public then<TResult1 = T, TResult2 = never>(
        onfulfilled?: ((value: T) => TResult1 | PromiseLike<TResult1>) | null,
        onrejected?: ((reason: any) => TResult2 | PromiseLike<TResult2>) | null
    ): Promise<TResult1 | TResult2> {
        return super.then(onfulfilled, onrejected);
        // res["_Abort"] = this._Abort
        // return res
    }

    public catch<TResult = never>(
        onrejected?: ((reason: any) => TResult | PromiseLike<TResult>) | null
    ): Promise<T | TResult> {
        return super.catch(onrejected);
        // res["_Abort"] = this._Abort
        // return res
    }

    public finally(onfinally?: (() => void) | null): Promise<T> {
        return super.finally(onfinally);
        // res["_Abort"] = this._Abort
        // return res
    }

    public _Abort() {
        this.extras.abort();
    }
}
